import { AirMeltCategoryInfo } from ".";
import { AirMeltCategory } from "../core/alloy-types";
import * as AirMeltElement from "./filter-logic/min-max-values";

export const AIRMELT_CATEGORIES = [
  { value: AirMeltCategory.CarbonAndLowAlloySteels, selected: true },
  { value: AirMeltCategory.CastToolSteels, selected: true },
  { value: AirMeltCategory.StainlessSteels, selected: true },
  { value: AirMeltCategory.NickelBase, selected: true },
  { value: AirMeltCategory.CobaltBase, selected: true }
];

export const INDUSTRY_NAME_CATEGORIES = [
  {
    category: "Cannon-Muskegon Title",
    options: [
      { value: "1020", text: "1020" },
      { value: "1025", text: "1025" },
      { value: "1030", text: "1030" }
    ]
  },
  { category: "Common Name", selected: true },
  { category: "Trade Name", selected: true },
  { category: "ASTM", selected: true },
  { category: "UNS", selected: true },
  { category: "DIN", selected: true },
  { category: "wNr", selected: true },
  { category: "afnor", selected: true }
];

export interface AirMeltState {
  drawerOpen: boolean;
  openFilter: string;
  searchTerm: string | null;

  currentPage: number,
  rowsPerPage: number,

  cmSelections: string[];
  commonNameSelections: string[];
  tradeNameSelections: string[];
  astmSelections: string[];
  amsSelections: string[];
  unsSelections: string[];
  dinSelections: string[];
  wnrSelections: string[];
  afnorSelections: string[];
  selectedCategories: AirMeltCategoryInfo[];

  siliconFilterSet: boolean;
  siliconMin: number;
  siliconMax: number;
  chromiumFilterSet: boolean;
  chromiumMin: number;
  chromiumMax: number;
  nickelFilterSet: boolean;
  nickelMin: number;
  nickelMax: number;
  molybdenumFilterSet: boolean;
  molybdenumMin: number;
  molybdenumMax: number;
  cobaltFilterSet: boolean;
  cobaltMin: number;
  cobaltMax: number;
  ironFilterSet: boolean;
  ironMin: number;
  ironMax: number;
}

export const INITIAL_STATE = {
  drawerOpen: false,
  openFilter: "", 
  searchTerm: null,

  currentPage: 1,
  rowsPerPage: 10,

  cmSelections: [],
  commonNameSelections: [],
  tradeNameSelections: [],
  astmSelections: [],
  amsSelections: [],
  unsSelections: [],
  dinSelections: [],
  wnrSelections: [],
  afnorSelections: [],
  selectedCategories: AIRMELT_CATEGORIES,
  siliconFilterSet: false,
  siliconMin: AirMeltElement.siliconInfo.minimum,
  siliconMax: AirMeltElement.siliconInfo.maximum,
  chromiumFilterSet: false,
  chromiumMin: AirMeltElement.chromiumInfo.minimum,
  chromiumMax: AirMeltElement.chromiumInfo.maximum,
  nickelFilterSet: false,
  nickelMin: AirMeltElement.nickelInfo.minimum,
  nickelMax: AirMeltElement.nickelInfo.maximum,
  molybdenumFilterSet: false,
  molybdenumMin: AirMeltElement.molybdenumInfo.minimum,
  molybdenumMax: AirMeltElement.molybdenumInfo.maximum,
  cobaltFilterSet: false,
  cobaltMin: AirMeltElement.cobaltInfo.minimum,
  cobaltMax: AirMeltElement.cobaltInfo.maximum,
  ironFilterSet: false,
  ironMin: AirMeltElement.ironInfo.minimum,
  ironMax: AirMeltElement.ironInfo.maximum,
};
